module.exports = __webpack_public_path__ + "static/media/heart-rate.269f5dfe.svg";